import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { mountPoint } from 'utils/generic/route-manipulation';
import { routePathWithMockedDataCheck } from 'utils/helpers';
import { isMobile } from 'utils/is-mobile';
import { SingleGameView } from 'newelements/Sportsbook/__partials/SingleGameView';
import { AdvancedGamesByCompetitions } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/AdvancedGamesByCompetitions';
import { GeneralEventsView } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/GeneralEventsView';
import { useAdvancedMarkets } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/useAdvancedMarkets';
import {
  DESKTOP_MAIN_CONTENT_ID,
  MOBILE_MAIN_CONTENT_ID
} from 'newelements/Sportsbook/layouts/advanced/constants/elements-ids';
import { QueryRoute } from 'components/QueryRoute';
import { HooryAiCardLazyWrapper } from 'newcomponents/Shared/generic/HooryAI/HooryAICard/HooryAiCardLazyWrapper';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import { getSportsData } from 'store/selectors/new-sportsbook';
import './index.less';

export const AdvancedMainContent = () => {
  const configs = useSportsbookConfigs();

  useAdvancedMarkets();

  const sportsData = useSelector(getSportsData)?.[configs.type];

  const isNoLiveGamesAvailable = sportsData === undefined;

  return (
    <div
      style={{ ...(isNoLiveGamesAvailable && { height: '100%' }) }}
      id={isMobile() ? MOBILE_MAIN_CONTENT_ID : DESKTOP_MAIN_CONTENT_ID}
    >
      <Route
        exact
        path={routePathWithMockedDataCheck(
          `${mountPoint(
            window.getPathname()
          )}/:sport?/:region?/:competition?/:game?`
        )}
        render={routeParams => {
          const { sport, region, competition, game } = routeParams.match.params;

          if (sport && region && competition && game && !isMobile()) {
            return <SingleGameView showAdvancedHeader />;
          } else {
            return (
              <>
                {isMobile() && <HooryAiCardLazyWrapper />}
                <QueryRoute
                  excludes={['compIds']}
                  render={() => <GeneralEventsView />}
                />
                <QueryRoute
                  includes={['compIds']}
                  render={() => <AdvancedGamesByCompetitions />}
                />
              </>
            );
          }
        }}
      />
    </div>
  );
};
